// drop-down options from the top-right user settings
import EditProfile from '../components/organisms/EditProfile';
import Logout from '../components/pages/UserSettings/Logout';
import { BillingIcon } from '../components/atoms/Iconography/MainNavigationIcons.jsx';
import { ReactComponent as SettingsIcon } from '../images/cog-icon.svg';
import { ReactComponent as SupportIcon } from '../images/support-icon.svg';
import { ReactComponent as LogoutIcon } from '../images/logout-icon.svg';
import { isBillingUiEnabled } from './billingFeatures';

/* Labels are carried as translation keys, not text: this module is imported at
   load time, before i18n has resolved a language, so the string has to be
   produced where the menu renders. */
export const userSettings = [
    { id: 'accountSettings', labelKey: 'navigation.userMenu.items.accountSettings', icon: SettingsIcon, component: EditProfile, accessLevel: 1},
    { id: 'managePlan', labelKey: 'navigation.userMenu.items.managePlan', icon: BillingIcon, path: '/billing', featureEnabled: isBillingUiEnabled, accessLevel: 1},
    { id: 'support', labelKey: 'navigation.userMenu.items.support', icon: SupportIcon, component: null, accessLevel: 1},
    { id: 'userLogout', labelKey: 'navigation.userMenu.items.userLogout', icon: LogoutIcon, component: Logout, accessLevel: 1}
];
